module.exports = __webpack_public_path__ + "img/18Grant.16e3e447.png";